<template>
  <div class="top-bar">
    <div class="w">
      <ul class="ul-l float-l">
        <!-- <li style="font-size: 12px;">客服电话：021-1234567 （周一至周五 9:00 - 18:00）</li> -->
      </ul>
      <ul class="ul-r float-r">
        <li v-if="token">
          <router-link to="/orders">我的订单</router-link>
        </li>
        <li class="spacer" v-if="token"></li>
        <li>
          <router-link v-if="!token" to="/login" class="link-login">您好，请登录</router-link>
          <a-dropdown v-else>
            <a class="ant-dropdown-link" href="#">
              欢迎您，{{ userInfo.nickname }}
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <router-link :to="`/personCenter/${userInfo.id}`">个人中心</router-link>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;" @click="logOut">退出登录</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
          <!-- <a class="link-regist colorRed">免费注册</a> -->
        </li>
      </ul>
    </div>
    <a-modal
      title="手机号绑定"
      :visible="bindPhoneVisible"
      @ok="bindPhone"
      @cancel="cancelVisible"
      ok-text="确认"
      cancel-text="取消"
      width="450px"
      :maskClosable="false"
      :closable="false"
    >
      <a-form-model
        :model="bindPhoneForm"
        ref="ruleForm"
        :rules="rules"
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
      >
        <a-form-model-item label="手机号" prop="phone">
          <a-input v-model="bindPhoneForm.phone" placeholder="请输入手机号" />
        </a-form-model-item>
        <a-form-model-item label="验证码" prop="code">
          <a-row :gutter="8">
            <a-col :span="12">
              <a-input placeholder="请输入验证码" v-model="bindPhoneForm.code" />
            </a-col>
            <a-col :span="12">
              <a-button @click="getCaptcha">{{ btnTitle }}</a-button>
            </a-col>
          </a-row>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { getToken, removeToken } from '@/utils/cookie'
import store from '@/store'
// import { mapGetters } from 'vuex'
import { mapState } from 'vuex'
import { getMsgCode, bindPhone } from '@/serve/auth'

export default {
  name: 'topBar',
  data () {
    return {
      token: store.getters.token || getToken(),
      btnTitle: '获取验证码',
      isBind: false,
      isFlag: false,
      timer: null,
      bindPhoneVisible: false,
      bindPhoneForm: {
        phone: '',
        code: ''
      },
      rules: {
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        }
      }
    }
  },
  computed: {
    // ...mapGetters(['userInfo'])
    ...mapState({
      userInfo: state => state.user.info
    })
  },
  methods: {
    // 绑定手机号
    bindPhone () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let params = {
            phone: this.bindPhoneForm.phone,
            code: this.bindPhoneForm.code,
            roleType: 'STUDENT'
          }
          bindPhone(params)
            .then(() => {
              this.$message.success('绑定成功！')
              this.bindPhoneVisible = false
              window.sessionStorage.setItem('isBind', true)
            })
            .catch(() => {
              this.isFlag = false
              this.$message.error('绑定失败, 请重试！')
            })
        }
      })
    },
    cancelVisible () {
      this.$message.info('请先完成手机号绑定！')
    },
    // 获取验证码
    getCaptcha () {
      if (!this.bindPhoneForm.phone || !/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.bindPhoneForm.phone)) {
        return this.$message.error('请输入合法手机号')
      }
      if (this.isFlag) return
      this.isFlag = true
      let time = 60
      let params = {
        phone: this.bindPhoneForm.phone,
        type: 'PHONE_BOND',
        roleType: 'STUDENT'
      }
      getMsgCode(params)
        .then(() => {
          this.timer = setInterval(() => {
            if (time > 0) {
              time--
              this.btnTitle = `${time}秒后重试`
            } else {
              this.btnTitle = '点击获取验证码'
              this.isFlag = false
              clearInterval(this.timer)
            }
          }, 1000)
        })
        .catch(err => {
          if ((err.status === 404 || err.status === 400) && !err.data.success) {
            this.$message.error(err.data.message)
          }
          this.btnTitle = '点击获取验证码'
          this.isFlag = false
          clearInterval(this.timer)
        })
    },
    logOut () {
      let that = this
      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        okText: '确定',
        cancelText: '取消',
        onOk () {
          removeToken()
          window.sessionStorage.clear()
          that.$router.push({ path: '/login' })
        },
        onCancel () {}
      })
    }
  },
  created () {
    let userInfo = JSON.parse(window.sessionStorage.getItem('info')) || ''
    let phone = userInfo.phone
    if (!Object.keys(userInfo).length) {
      window.sessionStorage.clear()
      return this.$router.push('/login')
    }
    if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(phone) && !window.sessionStorage.getItem('isBind')) {
      this.bindPhoneVisible = true
    }
  }
}
</script>
<style lang="less" scoped>
.top-bar {
  border-bottom: 1px solid #ddd;
  background-color: #f2f2f2;
  .w {
    height: 30px;
    line-height: 30px;
    color: #999;
    margin: auto;
    width: 1190px;
    a {
      color: #999;
      &:hover {
        color: #e33333;
      }
    }

    .ul-r {
      & > li {
        float: left;
        list-style: none;
      }
      .link-regist {
        margin-left: 10px;
      }
      .spacer {
        overflow: hidden;
        margin: 11px 10px 0;
        width: 1px;
        height: 10px;
        background-color: #ccc;
      }
    }
  }
}
</style>
